import type { CSSProperties } from "react";
import { Toaster as Sonner, ToasterProps } from "sonner";

import { useTheme } from "@/contexts/theme";

const TOASTER_FONT_FAMILY = '"IBM Plex Sans Arabic", sans-serif';

// Adapted from the reference: next-themes' useTheme replaced with our theme
// context so the toaster follows the app's resolved light/dark theme.
const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();
  const style = {
    "--normal-bg": "var(--popover)",
    "--normal-text": "var(--popover-foreground)",
    "--normal-border": "var(--border)",
    ...props.style,
    fontFamily: TOASTER_FONT_FAMILY,
  } as CSSProperties;
  const toastOptions = {
    ...props.toastOptions,
    style: {
      ...props.toastOptions?.style,
      fontFamily: TOASTER_FONT_FAMILY,
    },
  };

  return (
    <Sonner
      theme={resolvedTheme}
      className="tw:toaster tw:group"
      {...props}
      style={style}
      toastOptions={toastOptions}
    />
  );
};

export { Toaster };
